import { Tab, Tabs } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import LocalSEO from "./customer-website-local-seo";
import { useTabRoute } from "../../../hooks/useTabRoute";
import { TwentyPixelFontDiv } from "../../common-styling";
import CustomerWebsiteEditor from "./customer-website-editor";
import CustomerWebsiteFunnels from "./customer-website-funnels";
import CustomerWebsiteAnalytics from "./customer-website-analytics";
import { WEBSITE_TABS, WEBSITE_BASE_TAB_ROUTE } from "../../strings";
import { getCustomerPublishedWebsiteCount } from "../../../services/api-declaration";
import { useTranslation } from "react-i18next";

const CustomerWebsiteTabs = () => {
  const { t } = useTranslation();
  const { id: customerId } = useParams();
  const { tabRoute, tabLabel } = useTabRoute();
  const { EDITOR, FUNNELS, ANALYTICS, LOCAL_SEO } = WEBSITE_TABS;
  const [searchParams, setSearchParams] = useSearchParams();
  const [publishedWebsiteCount, setPublishedWebsiteCount] = useState(0);
  const isAnalyticsTabSelected = searchParams.get("view") === ANALYTICS;
  const isFunnelsTabSelected = searchParams.get("view") === FUNNELS;
  const isLocalSeoTabSelected = searchParams.get("view") === LOCAL_SEO;

  const handleSelectTab = (evKey) => {
    searchParams.set("view", evKey);
    setSearchParams(searchParams);
  };
  const fetchCustomerPublishedWebsiteCount = async () => {
    try {
      const response = await getCustomerPublishedWebsiteCount({ customerId });
      setPublishedWebsiteCount(response.data.data);
    } catch (error) {
      console.log("Error in fetchCustomerPublishedWebsiteCount ", error);
    }
  };

  const fetchPublishedCountCb = useCallback(
    fetchCustomerPublishedWebsiteCount,
    [customerId]
  );
  useEffect(() => {
    fetchPublishedCountCb();
  }, [fetchPublishedCountCb]);

  return (
    <>
      <TwentyPixelFontDiv className="mt-3 fw-bold">
        {tabLabel}
        {tabRoute !== WEBSITE_BASE_TAB_ROUTE && ` (Nested Website)`}
      </TwentyPixelFontDiv>
      <Tabs
        id="website-tabs"
        className="mt-4 mb-2"
        onSelect={(evKey) => handleSelectTab(evKey)}
        activeKey={searchParams.get("view") || EDITOR}
      >
        <Tab eventKey={EDITOR} title={"Editor"}>
          <CustomerWebsiteEditor />
        </Tab>
        <Tab eventKey={FUNNELS} title={t("website.funnels")}>
          <CustomerWebsiteFunnels isTabSelected={isFunnelsTabSelected} />
        </Tab>
        <Tab
          eventKey={ANALYTICS}
          title={t("website.analyticsHeading")}
          disabled={!publishedWebsiteCount}
        >
          <CustomerWebsiteAnalytics isTabSelected={isAnalyticsTabSelected} />
        </Tab>
        <Tab eventKey={LOCAL_SEO} title={t("localSeo.pageTitle")}>
          <LocalSEO
            isTabSelected={isLocalSeoTabSelected}
            isMainPublished={publishedWebsiteCount}
          />
        </Tab>
      </Tabs>
    </>
  );
};
export default CustomerWebsiteTabs;
